import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { nike } from '@nike/nike-design-tokens';
import { mobileOnly, navMenuOpen, navScrollable } from '../../utils/sharedStyles';
import { iconTertiary, iconTertiaryHover } from '../../utils/inconsistentVars';
const { podiumCdsColorFocusRing } = nike;

export const MOBILE_BTN_CLASS = 'mobile-btn';
export const profileImageClass = 'profile-image';
export const profileLinkClass = 'profile-link';

// NOTE: this will need to be updated to whatever is the root/lowest level
// of header nav elements once header/footer is broken out to individual sections.
export const globalStyleNavOverflow = css`
  #root {
    overflow: clip;
  }

  // makes the background scrollable when geomismatch modal is open (uses nav-scrollable alone to avoid dependency on nds-no-scroll which can be removed by other modals)
  .${navScrollable} {
    &:not(.${navMenuOpen}) {
      overflow: auto !important;
      position: static !important;
    }
  }
  .${navMenuOpen} {
    overflow: hidden;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
`;

/**
 * Podium uses css vars for the button icons that are not available on ncss 4.2
 * So overriding them using the values from sensible values that exist on both style sheets
 */
const btnIconsStyles = css`
  background: ${iconTertiary};
  color: var(--podium-cds-color-text-primary);

  &:hover,
  &:active {
    background: ${iconTertiaryHover};
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px ${podiumCdsColorFocusRing};
  }
`;

export const scrim = 'scrim';
export const isOpen = 'is-open';
export const navFavorites = 'nav-favorites';
export const isVisible = 'is-visible';
export const aiIconContainer = 'ai-icon-container';

export const StyledDiv = styled.div`
  float: right;
  gap: 4px;
  flex: 0 0 auto;
  display: flex;
  a.${navFavorites} {
    flex: 0 0 auto;
  }
  @media (${mobileOnly}) {
    .${navFavorites} {
      display: none;

      &.${isVisible} {
        display: flex;
      }
    }
  }
  /* Ensure all icon buttons don't shrink in flex layout */
  .nds-btn.nds-button--icon-only {
    flex: 0 0 auto;
    min-width: 36px; /* Prevent icon buttons from squishing below 36px */
    ${btnIconsStyles}
  }

  /* TG-8160/ALLY-9758: Add visible focus indicator to Nike AI Assistant button */
  /* Problem: Button had no visible focus state for keyboard users */
  /* Solution: Add box-shadow on :focus-visible (matches bag/favorites/profile icons) */
  /* Uses podiumCdsColorFocusRing from Nike Design Tokens for brand consistency */
  .nav-nike-ai-icon {
    &:focus-visible {
      box-shadow: 0 0 0 2px ${podiumCdsColorFocusRing};
    }
  }

  > a {
    flex: 0 0 auto;
  }

  .${MOBILE_BTN_CLASS} {
    display: flex;
    padding-left: 10px;
    flex: 0 0 auto; /* Prevent hamburger menu from shrinking */
  }

  .${profileImageClass} {
    border-radius: 24px;
    width: 24px;
    height: 24px;
    display: inline-block;
  }
  .${profileLinkClass} {
    display: flex;
    align-items: center;
    padding: 6px;
    border: none;
    border-radius: var(--podium-cds-button-border-radius);
    outline: none;
    ${btnIconsStyles}
  }

  .${scrim} {
    background-color: var(--podium-cds-color-scrim-100);
    bottom: 0;
    display: block;
    left: 0;
    opacity: 0;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 250ms, visibility 0s linear 250ms;
    visibility: hidden;
    z-index: 2;

    &.${isOpen} {
      opacity: 1;
      visibility: visible;
      transition: opacity 800ms ease, visibility 0s;
    }
    &.peekaboo-disabled {
      z-index: 2;
    }
  }
`;

export const BagContainer = styled.div`
  width: 24px;
  height: 24px;
  line-height: 1.75;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  text-align: center;
`;

export const BagCountText = styled.p`
  position: relative;
  font-size: 9px;
  top: -26px;
  left: 0px;
  width: 24px;
  height: 24px;
`;
